export const environment = {
  production: false,
  searchUrl: "https://dev.api.sds.basf.com:9446/api/search",
  advancedUserUrl: "https://dev.api.sds.basf.com:9446/api/isAdvancedUser",
  shortlinkUrl: "https://dev.api.sds.basf.com:9446/api/shortlink",
  qrlinkUrl: "https://dev.api.sds.basf.com:9446/api/qr",
  salesOrgUrl: "https://dev.api.sds.basf.com:9446/api/salesOrg",
  userFilterUrl: "https://dev.api.sds.basf.com:9446/api/user-filter",
  currentUserUrl: "https://dev.api.sds.basf.com:9446/api/user",
  viewUrl: "https://dev.api.sds.basf.com:9446/api/view",
  downloadUrl: "https://dev.api.sds.basf.com:9446/api/download",
  downloadZipUrl: "https://dev.api.sds.basf.com:9446/api/download-zip",
  releaseNotesUrl: "https://dev.api.sds.basf.com:9446/api/release-notes",
  feedbackUrl: "https://dev.api.sds.basf.com:9446/api/feedback",
  errorMessagesUrl: "https://dev.api.sds.basf.com:9446/api/error-messages",
  oidc: {
    authority: 'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/v2.0',
    clientId: 'f57e46a3-1b50-4c5b-b55b-0482c447f696',
    redirectUrl: 'https://dev.sds.basf.com/oauth/callback',
    postLogoutRedirectUri: 'https://dev.sds.basf.com',
    scopes: 'openid profile offline_access api://f57e46a3-1b50-4c5b-b55b-0482c447f696/user_impersonation',
    authorizationEndpoint: 'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/oauth2/v2.0/authorize',
    tokenEndpoint: 'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/oauth2/v2.0/token'
  }
};
